import { render, staticRenderFns } from "./ContentComponentEditor.vue?vue&type=template&id=eb4d517e&scoped=true&"
import script from "./ContentComponentEditor.vue?vue&type=script&lang=ts&"
export * from "./ContentComponentEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb4d517e",
  null
  
)

export default component.exports